import React from "react";
import LegalPageLayout from "../components/LegalPageLayout";
import { LegalSection, LegalP } from "../components/LegalContent";
import { useSeo } from "../lib/useSeo";

export default function RefundPolicyPage() {
  useSeo({
    title: "Debt Collector Kill Switch Digital Product Refund Policy",
    description: "Refund Policy for the Debt Collector Kill Switch digital educational and document-drafting product.",
    canonical: "https://debtcollectorkillswitch.com/refund-policy",
  });

  return (
    <LegalPageLayout pageTitle="Digital Product Refund Policy" effectiveDate="July 1, 2026">
      <LegalSection heading="DIGITAL DELIVERY GUARANTEE" testId="refund-digital-delivery-guarantee">
        <LegalP>
          Your Kill Switch files should be available after your completed purchase. If you experience an access or delivery problem, contact us at info@debtcollectorkillswitch.com and we will work to restore or re-deliver your files. If we are unable to provide the digital product you purchased, we will make the transaction right, including a refund where appropriate.
        </LegalP>
      </LegalSection>

      <LegalSection heading="OUR SUPPORT PROMISE" testId="refund-support-promise">
        <LegalP>
          Although digital purchases are final, we don&rsquo;t want you left wondering what to do next. If you&rsquo;re having difficulty accessing the Product, locating the materials relevant to your situation, or understanding where to begin, contact us at info@debtcollectorkillswitch.com. We will make a reasonable effort to help you access and navigate the Product. This support commitment does not guarantee any credit, collection, financial, or legal outcome.
        </LegalP>
      </LegalSection>

      <LegalSection heading="WE DO NOT OFFER REFUNDS FOR DIGITAL DOWNLOADS." testId="refund-no-refunds-notice">
        <LegalP>
          Because Debt Collector Kill Switch is delivered digitally and can be accessed, downloaded, saved, copied, or used immediately after purchase, all sales are final and non-refundable except where required by applicable law.
        </LegalP>
      </LegalSection>

      <LegalSection heading="1. No-Refund Policy for Digital Products">
        <LegalP>
          The Debt Collector Kill Switch is a digital product fulfilled by TDCR Consulting, LLC. Unlike a physical item, digital materials cannot be physically returned after access has been provided. Once access is delivered, the purchaser can retain, download, save, print, copy, or use the materials. For that reason, all purchases are final and non-refundable except where applicable law requires otherwise.
        </LegalP>
      </LegalSection>

      <LegalSection heading="2. Purchase Acknowledgment">
        <LegalP>
          By checking the applicable agreement box at checkout and completing your purchase, you acknowledge and agree that:
          (a) you are purchasing immediate access to digital content;
          (b) delivery or access may begin immediately after successful payment;
          (c) the Product is a self-help educational and document-drafting product and does not include representation or action taken on your behalf;
          (d) results are not guaranteed; and
          (e) the purchase is final and non-refundable except where a refund is required by law.
        </LegalP>
      </LegalSection>

      <LegalSection heading="3. No Refund Based on Results or Change of Mind">
        <LegalP>
          A refund will not be issued merely because you change your mind, do not use the Product, do not complete the steps, decide the materials are more detailed than expected, obtain a different result than expected, receive a response from a debt collector or bureau that you do not like, experience no deletion or credit-score change, or later decide to hire an attorney or another professional.
        </LegalP>
      </LegalSection>

      <LegalSection heading="4. No Outcome Guarantee">
        <LegalP>
          The Product provides educational materials and document-drafting tools. We do not guarantee collection deletion, a particular response, cessation of collection, dismissal of a lawsuit, reversal of a judgment or garnishment, removal from a credit report, credit-score improvement, or any other legal or financial result. Outcome dissatisfaction does not create a refund right.
        </LegalP>
      </LegalSection>

      <LegalSection heading="5. Duplicate Charges, Unauthorized Charges, or Access Problems">
        <LegalP>
          If you believe you were charged more than once for the same order, a transaction was unauthorized, or you cannot access the Product because of a technical issue on our side, contact us promptly at info@debtcollectorkillswitch.com. We will review the issue and, where appropriate, correct a duplicate or unauthorized charge, restore access, or take other reasonable action. Nothing in this Policy limits rights that cannot lawfully be waived.
        </LegalP>
      </LegalSection>

      <LegalSection heading="6. Please Contact Us Before Assuming the Product Is Not for You">
        <LegalP>
          Although purchases are non-refundable, we want you to be able to use what you purchased. If you genuinely believe the Product is not appropriate for your situation or you are confused about where to begin, email info@debtcollectorkillswitch.com. We can help explain how the materials are organized, identify where the relevant instructions are located, or clarify product access. Support does not include legal advice or representation and does not create a right to a refund.
        </LegalP>
      </LegalSection>

      <LegalSection heading="7. U.S.-Only Purchases">
        <LegalP>
          The Product is available only to U.S. residents located in the United States. Orders placed in violation of this restriction may be declined or cancelled. If we cancel an order before meaningful digital access is provided, we may reverse or refund the charge as appropriate.
        </LegalP>
      </LegalSection>

      <LegalSection heading="8. Payment Disputes">
        <LegalP>
          If you believe there is a billing error, duplicate charge, unauthorized transaction, or delivery problem, please contact us first so we can investigate. This request does not limit any rights you may have with your payment provider or under applicable law.
        </LegalP>
      </LegalSection>

      <LegalSection heading="9. Policy Changes">
        <LegalP>
          We may update this Refund Policy prospectively. The policy in effect at the time of purchase governs that purchase except to the extent applicable law requires otherwise.
        </LegalP>
      </LegalSection>

      <LegalSection heading="10. Contact">
        <LegalP>
          Refund-policy and billing questions may be sent to info@debtcollectorkillswitch.com.
        </LegalP>
      </LegalSection>
    </LegalPageLayout>
  );
}
